import React from 'react';
import { useQuery } from 'react-query';
import { dashboardApi } from '../../../../../api/dashboard';
import { ScaleLoader } from 'react-spinners';

const RecentLearningPaths = () => {
  const { data: paths, isLoading } = useQuery(
    ['admin-dashboard-recent-learning-paths'],
    () => dashboardApi.getRecentLearningPaths(),
    {
      cacheTime: 300000,
      staleTime: 300000,
      refetchOnWindowFocus: false,
      select: (res) => res?.data,
    }
  );

  return (
    <div className="bg-white p-4 shadow rounded-lg w-full">
      <h3 className="text-sm font-medium text-gray-700 mb-4 border-b pb-2">Recent Learning Paths</h3>

      {isLoading ? (
        <div className="flex items-center justify-center py-10">
          <ScaleLoader color="#0A3059" height={25} />
        </div>
      ) : !paths?.length ? (
        <p className="text-center text-gray-400 text-sm py-8">No recent learning paths found</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" className="px-4 py-3">Name</th>
                <th scope="col" className="px-4 py-3">Status</th>
                <th scope="col" className="px-4 py-3 text-center">Courses</th>
                <th scope="col" className="px-4 py-3 text-center">Enrolled</th>
              </tr>
            </thead>
            <tbody>
              {paths.map((path) => (
                <tr key={path?.id} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium text-gray-900">{path?.name ?? '—'}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        path?.status === 'published' || path?.status === 'active'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-800'
                      }`}
                    >
                      {path?.status
                        ? path.status.charAt(0).toUpperCase() + path.status.slice(1)
                        : '—'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center">{path?.courseCount ?? path?.courses ?? '—'}</td>
                  <td className="px-4 py-3 text-center">{path?.enrolledCount ?? path?.enrolled ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RecentLearningPaths;
